export const getDefaultAvatarText = (name?: string) => {
  const value = String(name || "U").trim() || "U";
  if (/^(?:微信)?用户.+/.test(value)) {
    return value.slice(-4).toUpperCase();
  }
  return value.slice(0, 1).toUpperCase();
};
